var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-1_outline",
    transform: "translate(-7.5 -5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13428",
    "data-name": "Path 13428",
    d: "M17.882,10.941,20,8.824,17.176,6,15.059,8.118m2.824,2.824L10.824,18H8V15.176l7.059-7.059m2.824,2.824L15.059,8.118",
    fill: "none",
    stroke: "#5593fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/editBlue.97c1055975239da81fb1229a49d71289.svg";
export { ForwardRef as ReactComponent };